import { DBManager } from "../db/dbManager"
import { GetUserID } from "../utils/common"

export async function GetContactsToSend(): Promise<any[]> {
    const contactList: any[] = []
    const results: any[] = await DBManager.readDataAllFromTable("contacts")
    const userId = GetUserID()
    results.forEach((contact: any) => {
        if (contact.role >= 2 && contact.userId == userId) {
            const ct = { contactId: contact.contactId, name: contact.name }
            contactList.push(ct)
        }
    })
    return contactList
}